import { createContext, useContext, useEffect, useState } from 'react';
import { getFingertipsLinks, getHealthSnapshot } from '../services/dashboard';
import { getAllCompanies } from '../services/pensionIndex';
import { AuthStore } from './auth';

export type savingSummaryState = {
  fingertipLinks: Array<any>;
};

export const SavingSummaryStore = createContext<savingSummaryState>({
  fingertipLinks: [],
});

const { Provider } = SavingSummaryStore;

export const SavingSummaryProvider = ({ children }: any) => {
  const [, , , selectedPersona] = useContext(AuthStore) || [];
  const [savingSummaryState, setSavingSummaryState] =
    useState<savingSummaryState>({
      fingertipLinks: [],
    });

  useEffect(() => {
    let healthSnapshot = getHealthSnapshot();
    let fingertipLinks = getFingertipsLinks(selectedPersona);
    let companiesMessages = getAllCompanies('persona-hw');

    setSavingSummaryState({
      fingertipLinks,
    });
  }, [selectedPersona]);

  return <Provider value={savingSummaryState}>{children}</Provider>;
};
